import script from "./AITools.vue?vue&type=script&setup=true&lang=js"
export * from "./AITools.vue?vue&type=script&setup=true&lang=js"

import "./AITools.vue?vue&type=style&index=0&id=fe05d39c&lang=css"

const __exports__ = script;

export default __exports__